import { render, staticRenderFns } from "./ListDefaultWebpart.vue?vue&type=template&id=0057f6b8"
import script from "./ListDefaultWebpart.ts?vue&type=script&lang=ts&external"
export * from "./ListDefaultWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports